/**
 * Manual pages definitions
 * Static menu item definitions for User Manual
 */

import * as HeroIcons from '@heroicons/react/24/outline';
import {
  Cog6ToothIcon,
  BriefcaseIcon,
} from '@heroicons/react/24/outline';
import {
  Cog6ToothIcon as Cog6ToothIconSolid,
  BriefcaseIcon as BriefcaseIconSolid,
} from '@heroicons/react/24/solid';
import { ROUTES } from '@/constants/routes';
import type { MenuItem } from '@/types/userManual';

export const getAdminPages = (t: (key: string) => string): MenuItem[] => [
  {
    icon: <HeroIcons.UserGroupIcon className="w-5 h-5" />,
    iconSolid: <HeroIcons.UserGroupIcon className="w-5 h-5" />,
    label: t('modules.users.title'),
    path: ROUTES.ADMIN_USERS,
    featureCode: 'ADMIN_USERS',
    description: t('copy.ui.manualUsersDesc'),
  },
  {
    icon: <HeroIcons.MapIcon className="w-5 h-5" />,
    iconSolid: <HeroIcons.MapIcon className="w-5 h-5" />,
    label: t('tripAnalysis.title'),
    path: '/admin/trip-analysis',
    featureCode: 'ADMIN_TRIP_ANALYSIS',
    description: t('copy.ui.manualTripCompareDesc'),
  },
  {
    icon: <Cog6ToothIcon className="w-5 h-5" />,
    iconSolid: <Cog6ToothIconSolid className="w-5 h-5" />,
    label: t('roles.title'),
    path: ROUTES.ADMIN_ROLES,
    featureCode: 'ADMIN_ROLES',
    description: t('copy.ui.manualRolesDesc'),
  },
  {
    icon: <HeroIcons.BuildingOffice2Icon className="w-5 h-5" />,
    iconSolid: <HeroIcons.BuildingOffice2Icon className="w-5 h-5" />,
    label: t('organizations.title'),
    path: ROUTES.ADMIN_ORGANIZATIONS,
    featureCode: 'ADMIN_ORGANIZATIONS',
    description: t('copy.ui.manualOrgHierarchyDesc'),
  },
  {
    icon: <HeroIcons.LanguageIcon className="w-5 h-5" />,
    iconSolid: <HeroIcons.LanguageIcon className="w-5 h-5" />,
    label: t('translations.title'),
    path: ROUTES.ADMIN_TRANSLATIONS,
    featureCode: 'ADMIN_TRANSLATIONS',
    description: t('copy.ui.manualTranslationsDesc'),
  },
  {
    icon: <HeroIcons.MapPinIcon className="w-5 h-5" />,
    iconSolid: <HeroIcons.MapPinIcon className="w-5 h-5" />,
    label: 'Geofences',
    path: ROUTES.ADMIN_GEOFENCES,
    featureCode: 'ADMIN_GEOFENCES',
    description: t('copy.ui.manualGeofenceZonesDesc'),
  },
  {
    icon: <HeroIcons.BellAlertIcon className="w-5 h-5" />,
    iconSolid: <HeroIcons.BellAlertIcon className="w-5 h-5" />,
    label: t('modules.geofence-events.title'),
    path: ROUTES.ADMIN_GEOFENCE_EVENTS,
    featureCode: 'ADMIN_GEOFENCE_EVENTS',
    description: t('copy.ui.manualGeofenceEventsDesc'),
  },
  {
    icon: <HeroIcons.ArrowDownTrayIcon className="w-5 h-5" />,
    iconSolid: <HeroIcons.ArrowDownTrayIcon className="w-5 h-5" />,
    label: 'Import',
    path: ROUTES.ADMIN_IMPORTS,
    featureCode: 'ADMIN_IMPORTS',
    description: t('copy.ui.manualImportDesc'),
  },
  {
    icon: <HeroIcons.CubeIcon className="w-5 h-5" />,
    iconSolid: <HeroIcons.CubeIcon className="w-5 h-5" />,
    label: t('modules.packages.title'),
    path: ROUTES.ADMIN_PACKAGES,
    featureCode: 'ADMIN_PACKAGES',
    description: t('copy.ui.manualPackagesDesc'),
  },
  {
    icon: <HeroIcons.DevicePhoneMobileIcon className="w-5 h-5" />,
    iconSolid: <HeroIcons.DevicePhoneMobileIcon className="w-5 h-5" />,
    label: t('admin.devices'),
    path: ROUTES.ADMIN_DEVICES,
    featureCode: 'ADMIN_DEVICES',
    description: t('copy.ui.manualDevicesDesc'),
  },
  {
    icon: <HeroIcons.WrenchScrewdriverIcon className="w-5 h-5" />,
    iconSolid: <HeroIcons.WrenchScrewdriverIcon className="w-5 h-5" />,
    label: t('admin.deviceManagement'),
    path: ROUTES.ADMIN_DEVICE_MANAGEMENT,
    featureCode: 'ADMIN_DEVICE_MANAGEMENT',
    description: t('copy.ui.manualDeviceAdminDesc'),
  },
  {
    icon: <HeroIcons.SignalIcon className="w-5 h-5" />,
    iconSolid: <HeroIcons.SignalIcon className="w-5 h-5" />,
    label: t('copy.ui.manualSimCards'),
    path: ROUTES.ADMIN_SIM_CARDS,
    featureCode: 'ADMIN_SIM_CARDS',
    description: t('copy.ui.manualSimCardsDesc'),
  },
  {
    icon: <HeroIcons.CpuChipIcon className="w-5 h-5" />,
    iconSolid: <HeroIcons.CpuChipIcon className="w-5 h-5" />,
    label: t('eyeInventory.title'),
    path: ROUTES.ADMIN_EYE_INVENTORY,
    featureCode: 'ADMIN_EYE_INVENTORY',
    description: t('eyeInventory.description'),
  },
  {
    icon: <HeroIcons.ChatBubbleLeftRightIcon className="w-5 h-5" />,
    iconSolid: <HeroIcons.ChatBubbleLeftRightIcon className="w-5 h-5" />,
    label: 'Support',
    path: ROUTES.ADMIN_SUPPORT,
    featureCode: 'ADMIN_SUPPORT',
    description: t('copy.ui.manualSupportDesc'),
  },
];

export const getOtherPages = (t: (key: string) => string): MenuItem[] => [
  {
    icon: <HeroIcons.MapIcon className="w-5 h-5" />,
    iconSolid: <HeroIcons.MapIcon className="w-5 h-5" />,
    label: t('liveTracking.title'),
    path: ROUTES.LIVE_TRACKING,
    featureCode: 'LIVE_TRACKING',
    description: t('copy.ui.manualLiveTrackingDesc'),
  },
  {
    icon: <HeroIcons.FireIcon className="w-5 h-5" />,
    iconSolid: <HeroIcons.FireIcon className="w-5 h-5" />,
    label: 'Heatmap',
    path: ROUTES.ANALYSIS_HEATMAP,
    featureCode: 'ANALYSIS_HEATMAP',
    description: t('copy.ui.manualHeatmapDesc'),
  },
];

export const getReportPages = (t: (key: string) => string): MenuItem[] => [
  {
    icon: <HeroIcons.ClipboardDocumentListIcon className="w-5 h-5" />,
    iconSolid: <HeroIcons.ClipboardDocumentListIcon className="w-5 h-5" />,
    label: t('modules.trips.title'),
    path: ROUTES.REPORTS_TRIPS,
    featureCode: 'REPORTS_TRIPS',
    description: t('copy.ui.manualTripsDesc'),
  },
  {
    icon: <HeroIcons.DocumentTextIcon className="w-5 h-5" />,
    iconSolid: <HeroIcons.DocumentTextIcon className="w-5 h-5" />,
    label: t('reports.drivingLog.title'),
    path: ROUTES.REPORTS_DRIVING_LOG,
    featureCode: 'REPORTS_DRIVING_LOG',
    description: t('copy.ui.manualDrivingLogDesc'),
  },
  {
    icon: <HeroIcons.ArrowTrendingUpIcon className="w-5 h-5" />,
    iconSolid: <HeroIcons.ArrowTrendingUpIcon className="w-5 h-5" />,
    label: t('copy.ui.manualEcoDriving'),
    path: ROUTES.REPORTS_ECO_DRIVING,
    featureCode: 'REPORTS_ECO_DRIVING',
    description: t('copy.ui.manualEcoDrivingDesc'),
  },
  {
    icon: <HeroIcons.ExclamationTriangleIcon className="w-5 h-5" />,
    iconSolid: <HeroIcons.ExclamationTriangleIcon className="w-5 h-5" />,
    label: t('copy.ui.manualSpeedViolations'),
    path: ROUTES.REPORTS_SPEED_COMPLIANCE,
    featureCode: 'REPORTS_SPEED_COMPLIANCE',
    description: t('copy.ui.manualSpeedViolationsDesc'),
  },
  {
    icon: <HeroIcons.BoltIcon className="w-5 h-5" />,
    iconSolid: <HeroIcons.BoltIcon className="w-5 h-5" />,
    label: t('reports.energyConsumption.title'),
    path: ROUTES.REPORTS_ENERGY_CONSUMPTION,
    featureCode: 'REPORTS_ENERGY_CONSUMPTION',
    description: t('copy.ui.manualEnergyDesc'),
  },
  {
    icon: <HeroIcons.WrenchIcon className="w-5 h-5" />,
    iconSolid: <HeroIcons.WrenchIcon className="w-5 h-5" />,
    label: t('reports.vehicleWear.title'),
    path: ROUTES.REPORTS_VEHICLE_WEAR,
    featureCode: 'REPORTS_VEHICLE_WEAR',
    description: t('copy.ui.manualWearDesc'),
  },
  {
    icon: <HeroIcons.ClockIcon className="w-5 h-5" />,
    iconSolid: <HeroIcons.ClockIcon className="w-5 h-5" />,
    label: t('reports.underutilized.title'),
    path: ROUTES.REPORTS_UNDERUTILIZED,
    featureCode: 'REPORTS_UNDERUTILIZED',
    description: t('copy.ui.manualUnderutilizedDesc'),
  },
  {
    icon: <HeroIcons.GlobeEuropeAfricaIcon className="w-5 h-5" />,
    iconSolid: <HeroIcons.GlobeEuropeAfricaIcon className="w-5 h-5" />,
    label: t('copy.ui.manualCo2'),
    path: ROUTES.REPORTS_CO2,
    featureCode: 'REPORTS_CO2',
    description: t('copy.ui.manualCo2Desc'),
  },
  {
    icon: <HeroIcons.CalendarDaysIcon className="w-5 h-5" />,
    iconSolid: <HeroIcons.CalendarDaysIcon className="w-5 h-5" />,
    label: t('reports.bookingStats.title'),
    path: ROUTES.REPORTS_BOOKING_STATS,
    featureCode: 'REPORTS_BOOKING_STATS',
    description: t('copy.ui.manualBookingStatsDesc'),
  },
  {
    icon: <HeroIcons.MapPinIcon className="w-5 h-5" />,
    iconSolid: <HeroIcons.MapPinIcon className="w-5 h-5" />,
    label: t('copy.ui.manualGeofenceZones'),
    path: ROUTES.REPORTS_GEOFENCE_ZONES,
    featureCode: 'REPORTS_GEOFENCE_ZONES',
    description: t('copy.ui.manualGeofenceReportDesc'),
  },
  {
    icon: <HeroIcons.BeakerIcon className="w-5 h-5" />,
    iconSolid: <HeroIcons.BeakerIcon className="w-5 h-5" />,
    label: t('reports.fuelAnalysis.title'),
    path: ROUTES.REPORTS_FUEL_ANALYSIS,
    featureCode: 'REPORTS_FUEL_ANALYSIS',
    description: t('copy.ui.manualFuelDesc'),
  },
  {
    icon: <HeroIcons.CurrencyDollarIcon className="w-5 h-5" />,
    iconSolid: <HeroIcons.CurrencyDollarIcon className="w-5 h-5" />,
    label: t('reports.fleetTco.title'),
    path: ROUTES.REPORTS_FLEET_TCO,
    featureCode: 'REPORTS_FLEET_TCO',
    description: t('copy.ui.manualTcoDesc'),
  },
  {
    icon: <HeroIcons.PresentationChartLineIcon className="w-5 h-5" />,
    iconSolid: <HeroIcons.PresentationChartLineIcon className="w-5 h-5" />,
    label: t('reports.executive.title'),
    path: ROUTES.REPORTS_EXECUTIVE,
    featureCode: 'REPORTS_EXECUTIVE',
    description: t('copy.ui.manualExecutiveDesc'),
  },
];

export const getSysadminPages = (t: (key: string) => string): MenuItem[] => [
  {
    icon: <HeroIcons.CircleStackIcon className="w-5 h-5" />,
    iconSolid: <HeroIcons.CircleStackIcon className="w-5 h-5" />,
    label: t('copy.ui.manualDataMigration'),
    path: ROUTES.SYSADMIN_DATA_MIGRATION,
    featureCode: 'SYSADMIN_DATA_MIGRATION',
    description: t('copy.ui.manualDataMigrationDesc'),
  },
  {
    icon: <HeroIcons.CommandLineIcon className="w-5 h-5" />,
    iconSolid: <HeroIcons.CommandLineIcon className="w-5 h-5" />,
    label: t('copy.ui.manualDeviceCommands'),
    path: ROUTES.SYSADMIN_DEVICE_COMMANDS,
    featureCode: 'SYSADMIN_DEVICE_COMMANDS',
    description: t('copy.ui.manualDeviceCommandsDesc'),
  },
  {
    icon: <HeroIcons.ClipboardDocumentCheckIcon className="w-5 h-5" />,
    iconSolid: <HeroIcons.ClipboardDocumentCheckIcon className="w-5 h-5" />,
    label: t('copy.ui.manualAuditLog'),
    path: ROUTES.SYSADMIN_AUDIT_LOG,
    featureCode: 'SYSADMIN_AUDIT_LOG',
    description: t('copy.ui.manualAuditLogDesc'),
  },
  {
    icon: <HeroIcons.DocumentMagnifyingGlassIcon className="w-5 h-5" />,
    iconSolid: <HeroIcons.DocumentMagnifyingGlassIcon className="w-5 h-5" />,
    label: t('copy.ui.manualGeneralAudit'),
    path: ROUTES.SYSADMIN_GENERAL_AUDIT_LOG,
    featureCode: 'SYSADMIN_GENERAL_AUDIT_LOG',
    description: t('copy.ui.manualGeneralAuditDesc'),
  },
  {
    icon: <HeroIcons.ExclamationCircleIcon className="w-5 h-5" />,
    iconSolid: <HeroIcons.ExclamationCircleIcon className="w-5 h-5" />,
    label: t('copy.ui.manualErrorLogs'),
    path: ROUTES.SYSADMIN_ERROR_LOG,
    featureCode: 'SYSADMIN_ERROR_LOG',
    description: t('copy.ui.manualErrorLogsDesc'),
  },
  {
    icon: <HeroIcons.AdjustmentsHorizontalIcon className="w-5 h-5" />,
    iconSolid: <HeroIcons.AdjustmentsHorizontalIcon className="w-5 h-5" />,
    label: t('modules.eco-settings.title'),
    path: ROUTES.SYSADMIN_ECO_SETTINGS,
    featureCode: 'SYSADMIN_ECO_SETTINGS',
    description: t('copy.ui.manualEcoSettingsDesc'),
  },
  {
    icon: <HeroIcons.ComputerDesktopIcon className="w-5 h-5" />,
    iconSolid: <HeroIcons.ComputerDesktopIcon className="w-5 h-5" />,
    label: t('copy.ui.manualSystemMonitor'),
    path: ROUTES.SYSADMIN_SYSTEM_MONITOR,
    featureCode: 'SYSADMIN_SYSTEM_MONITOR',
    description: t('copy.ui.manualSystemMonitorDesc'),
  },
  {
    icon: <HeroIcons.ClockIcon className="w-5 h-5" />,
    iconSolid: <HeroIcons.ClockIcon className="w-5 h-5" />,
    label: t('copy.ui.manualSlowQueries'),
    path: ROUTES.SYSADMIN_SLOW_QUERIES,
    featureCode: 'SYSADMIN_SLOW_QUERIES',
    description: t('copy.ui.manualSlowQueriesDesc'),
  },
  {
    icon: <HeroIcons.ShieldCheckIcon className="w-5 h-5" />,
    iconSolid: <HeroIcons.ShieldCheckIcon className="w-5 h-5" />,
    label: t('copy.ui.manualCertMonitor'),
    path: ROUTES.SYSADMIN_CERTIFICATE_MONITOR,
    featureCode: 'SYSADMIN_CERT_MONITOR',
    description: t('copy.ui.manualCertMonitorDesc'),
  },
  {
    icon: <HeroIcons.LockClosedIcon className="w-5 h-5" />,
    iconSolid: <HeroIcons.LockClosedIcon className="w-5 h-5" />,
    label: 'Security',
    path: ROUTES.SYSADMIN_SECURITY,
    featureCode: 'SYSADMIN',
    description: t('copy.ui.manualSecurityDesc'),
  },
  {
    icon: <HeroIcons.QueueListIcon className="w-5 h-5" />,
    iconSolid: <HeroIcons.QueueListIcon className="w-5 h-5" />,
    label: t('modules.device-queues.title'),
    path: ROUTES.SYSADMIN_DEVICE_QUEUES,
    featureCode: 'SYSADMIN_DEVICE_QUEUES',
    description: t('copy.ui.manualDeviceQueuesDesc'),
  },
  {
    icon: <HeroIcons.ArrowPathIcon className="w-5 h-5" />,
    iconSolid: <HeroIcons.ArrowPathIcon className="w-5 h-5" />,
    label: t('copy.ui.manualDataReplay'),
    path: ROUTES.SYSADMIN_DATA_REPLAY,
    featureCode: 'SYSADMIN_DATA_REPLAY',
    description: t('copy.ui.manualDataReplayDesc'),
  },
];

export const getCrmPages = (t: (key: string) => string): MenuItem[] => [
  {
    icon: <BriefcaseIcon className="w-5 h-5" />,
    iconSolid: <BriefcaseIconSolid className="w-5 h-5" />,
    label: 'CRM',
    path: ROUTES.CRM,
    featureCode: 'CRM',
    description: t('copy.ui.manualCrmDesc'),
  },
  {
    icon: <HeroIcons.UserGroupIcon className="w-5 h-5" />,
    iconSolid: <HeroIcons.UserGroupIcon className="w-5 h-5" />,
    label: t('crm.customers'),
    path: ROUTES.CRM_CUSTOMERS,
    featureCode: 'CRM_CUSTOMERS',
    description: t('copy.ui.manualCustomersDesc'),
  },
  {
    icon: <HeroIcons.PlusCircleIcon className="w-5 h-5" />,
    iconSolid: <HeroIcons.PlusCircleIcon className="w-5 h-5" />,
    label: t('copy.ui.manualNewCustomer'),
    path: ROUTES.CRM_CUSTOMER_WIZARD,
    featureCode: 'CRM_CUSTOMER_WIZARD',
    description: t('copy.ui.manualNewCustomerDesc'),
  },
  {
    icon: <HeroIcons.CurrencyDollarIcon className="w-5 h-5" />,
    iconSolid: <HeroIcons.CurrencyDollarIcon className="w-5 h-5" />,
    label: t('crm.pricelist'),
    path: ROUTES.CRM_PRICELIST,
    featureCode: 'CRM_PRICELIST',
    description: t('copy.ui.manualPricelistDesc'),
  },
  {
    icon: <HeroIcons.FolderIcon className="w-5 h-5" />,
    iconSolid: <HeroIcons.FolderIcon className="w-5 h-5" />,
    label: t('crm.projects'),
    path: ROUTES.CRM_PROJECTS,
    featureCode: 'CRM_PROJECTS',
    description: t('crm.projectsDescription'),
  },
  {
    icon: <HeroIcons.ChartBarSquareIcon className="w-5 h-5" />,
    iconSolid: <HeroIcons.ChartBarSquareIcon className="w-5 h-5" />,
    label: t('crm.pipeline'),
    path: ROUTES.CRM_PIPELINE,
    featureCode: 'CRM_PIPELINE',
    description: t('copy.ui.manualPipelineDesc'),
  },
  {
    icon: <HeroIcons.DocumentTextIcon className="w-5 h-5" />,
    iconSolid: <HeroIcons.DocumentTextIcon className="w-5 h-5" />,
    label: t('crm.procurements'),
    path: ROUTES.CRM_PROCUREMENTS,
    featureCode: 'CRM_PROCUREMENTS',
    description: t('crm.procurementsDescription'),
  },
  {
    icon: <HeroIcons.ChartBarIcon className="w-5 h-5" />,
    iconSolid: <HeroIcons.ChartBarIcon className="w-5 h-5" />,
    label: t('crm.economyOverview'),
    path: ROUTES.CRM_ECONOMY_OVERVIEW,
    featureCode: 'CRM_ECONOMY',
    description: t('crm.economyOverviewDescription'),
  },
];

export const getBookingPages = (t: (key: string) => string): MenuItem[] => [
  {
    icon: <HeroIcons.ArrowPathIcon className="w-5 h-5" />,
    iconSolid: <HeroIcons.ArrowPathIcon className="w-5 h-5" />,
    label: t('booking.vehicleReplacementTitle'),
    path: '/booking/vehicle-replacement',
    featureCode: 'BOOKING_VEHICLE_REPLACEMENT',
    description: t('modules.vehicle-replacement.description'),
  },
  {
    icon: <HeroIcons.TruckIcon className="w-5 h-5" />,
    iconSolid: <HeroIcons.TruckIcon className="w-5 h-5" />,
    label: t('booking.ownCar.formTitle'),
    path: '/booking/own-car-trips',
    featureCode: 'BOOKING_OWN_CAR_TRIP',
    description: t('modules.own-car-trip.description'),
  },
  {
    icon: <HeroIcons.MapPinIcon className="w-5 h-5" />,
    iconSolid: <HeroIcons.MapPinIcon className="w-5 h-5" />,
    label: t('modules.pickup-locations.title'),
    path: '/booking/pickup-locations',
    featureCode: 'BOOKING_PICKUP_LOCATIONS',
    description: t('modules.pickup-locations.description'),
  },
];


export function buildManualPages(t: (key: string) => string) {
  return {
    admin: getAdminPages(t),
    other: getOtherPages(t),
    reports: getReportPages(t),
    sysadmin: getSysadminPages(t),
    crm: getCrmPages(t),
    booking: getBookingPages(t),
  };
}

// Icon categories for display
export const iconCategories: Record<string, string[]> = {
  navigation: [
    'TruckIcon', 'MapIcon', 'ChartBarIcon', 'UserIcon', 'BookOpenIcon',
    'HomeIcon', 'BuildingOfficeIcon', 'BuildingOffice2Icon', 'MapPinIcon',
    'GlobeAltIcon', 'GlobeAmericasIcon', 'GlobeEuropeAfricaIcon',
  ],
  arrows: [
    'ArrowLeftIcon', 'ArrowRightIcon', 'ArrowUpIcon', 'ArrowDownIcon',
    'ArrowPathIcon', 'ArrowPathRoundedSquareIcon', 'ArrowUturnLeftIcon',
    'ArrowUturnRightIcon', 'ArrowUturnUpIcon', 'ArrowUturnDownIcon',
    'ChevronLeftIcon', 'ChevronRightIcon', 'ChevronUpIcon', 'ChevronDownIcon',
    'ChevronDoubleLeftIcon', 'ChevronDoubleRightIcon', 'ChevronDoubleUpIcon', 'ChevronDoubleDownIcon',
  ],
  actions: [
    'MagnifyingGlassIcon', 'BellIcon', 'MoonIcon', 'SunIcon', 'EyeIcon', 'EyeSlashIcon',
    'PlusIcon', 'MinusIcon', 'XMarkIcon', 'CheckIcon', 'PencilIcon', 'TrashIcon',
    'ShareIcon', 'DownloadIcon', 'UploadIcon', 'ArrowDownTrayIcon', 'ArrowUpTrayIcon',
    'PrinterIcon', 'DocumentIcon', 'DocumentTextIcon', 'DocumentDuplicateIcon',
    'ClipboardIcon', 'ClipboardDocumentIcon', 'ClipboardDocumentCheckIcon',
    'FunnelIcon', 'AdjustmentsHorizontalIcon', 'AdjustmentsVerticalIcon',
    'PlayIcon', 'PauseIcon', 'StopIcon', 'ForwardIcon', 'BackwardIcon',
  ],
  admin: [
    'Cog6ToothIcon', 'Cog8ToothIcon', 'CircleStackIcon', 'ServerIcon',
    'UserGroupIcon', 'UsersIcon', 'UserCircleIcon', 'UserPlusIcon',
    'ShieldCheckIcon', 'ShieldExclamationIcon', 'LockClosedIcon', 'LockOpenIcon',
    'KeyIcon', 'IdentificationIcon', 'CreditCardIcon', 'BanknotesIcon',
    'WrenchScrewdriverIcon', 'WrenchIcon', 'ToolIcon',
  ],
  communication: [
    'ChatBubbleLeftIcon', 'ChatBubbleLeftRightIcon', 'ChatBubbleOvalLeftIcon',
    'EnvelopeIcon', 'EnvelopeOpenIcon', 'PhoneIcon', 'VideoCameraIcon',
    'MegaphoneIcon', 'SpeakerWaveIcon', 'SpeakerXMarkIcon',
  ],
  files: [
    'FolderIcon', 'FolderOpenIcon', 'DocumentIcon', 'DocumentTextIcon',
    'DocumentDuplicateIcon', 'DocumentArrowDownIcon', 'DocumentArrowUpIcon',
    'PhotoIcon', 'FilmIcon', 'MusicalNoteIcon',
  ],
  status: [
    'CheckCircleIcon', 'XCircleIcon', 'ExclamationCircleIcon', 'ExclamationTriangleIcon',
    'InformationCircleIcon', 'QuestionMarkCircleIcon', 'ClockIcon',
    'CheckBadgeIcon', 'XMarkIcon', 'CheckIcon',
  ],
  media: [
    'PhotoIcon', 'CameraIcon', 'VideoCameraIcon', 'FilmIcon',
    'MusicalNoteIcon', 'SpeakerWaveIcon', 'PlayIcon', 'PauseIcon',
  ],
  other: [
    'HeartIcon', 'StarIcon', 'BookmarkIcon', 'TagIcon', 'HashtagIcon',
    'CalendarIcon', 'CalendarDaysIcon', 'ClockIcon', 'StopwatchIcon',
    'ShoppingCartIcon', 'GiftIcon', 'FireIcon', 'LightBulbIcon',
    'BoltIcon', 'Battery0Icon', 'Battery50Icon', 'Battery100Icon',
    'WifiIcon', 'SignalIcon', 'SignalSlashIcon',
    'CubeIcon', 'CubeTransparentIcon', 'PuzzlePieceIcon',
    'FlagIcon', 'TrophyIcon', 'AcademicCapIcon', 'GraduationCapIcon',
    'BriefcaseIcon', 'SuitcaseIcon', 'BuildingLibraryIcon',
    'BeakerIcon', 'FlaskIcon', 'MicroscopeIcon',
    'PaintBrushIcon', 'SwatchIcon', 'ColorSwatchIcon',
    'RocketLaunchIcon', 'SparklesIcon', 'FireIcon',
  ],
};
